var defaults = {};
export default defaults;